import styled from 'styled-components'

import { Image } from '@/ui'

export const ProfileImage = styled(Image).attrs({
  square: true,
})<{ size: string }>`
  margin-right: 1em;
  border-radius: 100%;
  width: ${props => props.size};
  height: ${props => props.size};
  object-fit: cover;
`
